import React from 'react';
import { syncBlock } from '@atlaskit/adf-schema';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { IconSyncBlock } from '@atlaskit/editor-common/quick-insert';
import { SyncBlockStoreManager } from '@atlaskit/editor-synced-block-provider';
import { createSyncedBlock } from './pm-plugins/actions';
import { createPlugin } from './pm-plugins/main';
import { getBlockMenuComponents } from './ui/block-menu-components';
import { ContentComponent } from './ui/ContentComponent';
import { getToolbarConfig } from './ui/floating-toolbar';
export var syncedBlockPlugin = function syncedBlockPlugin(_ref) {
  var _api$blockMenu;
  var config = _ref.config,
    api = _ref.api;
  var syncBlockStore = new SyncBlockStoreManager(config === null || config === void 0 ? void 0 : config.dataProvider);
  api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents(getBlockMenuComponents(api));
  return {
    name: 'syncedBlock',
    nodes: function nodes() {
      return [{
        name: 'syncBlock',
        node: syncBlock
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'syncedBlockPlugin',
        plugin: function plugin(params) {
          return createPlugin(config, params, syncBlockStore, api);
        }
      }];
    },
    commands: {
      insertSyncedBlock: function insertSyncedBlock() {
        return function (_ref2) {
          var tr = _ref2.tr;
          return createSyncedBlock(tr, syncBlockStore) || null;
        };
      }
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        return [{
          id: 'syncBlock',
          title: formatMessage(blockTypeMessages.syncedBlock),
          description: formatMessage(blockTypeMessages.syncedBlockDescription),
          priority: 800,
          keywords: ['synced', 'block', 'synced-block', 'sync', 'sync-block', 'auto', 'update', 'excerpt', 'connect'],
          keyshortcut: '',
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconSyncBlock, {
              label: formatMessage(blockTypeMessages.syncedBlock)
            });
          },
          action: function action(insert, state) {
            return createSyncedBlock(state.tr, syncBlockStore, insert);
          }
        }];
      },
      floatingToolbar: function floatingToolbar(state, intl, providerFactory) {
        return getToolbarConfig(state, intl, config, providerFactory, api, syncBlockStore);
      }
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(ContentComponent, {
        syncBlockStoreManager: syncBlockStore
      });
    }
  };
};